import React from 'react';
import { FormsyText } from 'formsy-material-ui';

const TextField = (props) => {

    const hintText = ((!props.hintText || !props.required ) ? props.hintText : `${props.hintText} *`);
    const floatingLabelText = ((!props.floatingLabelText || !props.required) ? props.floatingLabelText : `${props.floatingLabelText} *`);
    return (
        <FormsyText
            {...props}
            floatingLabelText={floatingLabelText}
            hintText={hintText}
            className="input-field text"
            fullWidth={true}
        />
    );
};

export default TextField;
